import React from "react";

const LOGOS = [
    "Prothom Alo",
    "bdnews24",
    "Kaler Kantho",
    "Jugantor",
    "The Daily Star",
    "Samakal",
    "BD Pratidin",
    "Ittefaq",
    "Manab Zamin",
    "Anandabazar",
];

export const TrustStrip = () => {
    const items = [...LOGOS, ...LOGOS];
    return (
        <section data-testid="trust-strip" className="relative py-10 lg:py-16">
            <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
                <p className="text-center text-[11px] uppercase tracking-[0.22em] font-semibold text-ink-muted mb-6">
                    Built for Bangladesh's leading newsrooms
                </p>
                <div className="bg-ink-pill rounded-full py-4 px-2 overflow-hidden marquee-mask shadow-pill">
                    <div className="flex gap-12 animate-marquee whitespace-nowrap" style={{ width: "max-content" }}>
                        {items.map((name, i) => (
                            <div key={i} className="flex items-center gap-3 px-4 flex-shrink-0">
                                <span className="w-1.5 h-1.5 rounded-full bg-coral"/>
                                <span className="font-display text-cream-100 text-[18px] lg:text-[22px] font-medium tracking-tight italic-display">
                                    {name}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
